"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M16.5 2a.5.5 0 1 0 0 1h2.03c-1.294 1.608-3.414 3.129-5.812 4.3C9.949 8.655 6.9 9.5 4.5 9.5a.5.5 0 0 0 0 1c2.6 0 5.8-.904 8.657-2.3 2.287-1.12 4.41-2.58 5.843-4.208V5.5a.5.5 0 1 0 1 0v-3a.5.5 0 0 0-.5-.5zm-.5 8.5A1.5 1.5 0 0 1 17.5 9h1a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5zm-6 2a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5zm-6 2A1.5 1.5 0 0 1 5.5 13h1A1.5 1.5 0 0 1 8 14.5v4A1.5 1.5 0 0 1 6.5 20h-1A1.5 1.5 0 0 1 4 18.5z"
}), 'ChartFilled');
